import React from 'react';

const Impressum = () => {
  return (
    <div className="sterbegeld-landing">
      <section className="section">
        <div className="container-custom" style={{ maxWidth: '900px' }}>
          <h1 style={{ marginBottom: '2rem', textAlign: 'center' }}>Impressum</h1>
          
          <div style={{ background: 'white', padding: '3rem', borderRadius: '24px', boxShadow: 'var(--shadow-md)' }}>
            <div style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Kontakt</h2>
              <p style={{ marginBottom: '0.5rem' }}><strong>Marcel Peev</strong></p>
              <p style={{ marginBottom: '0.5rem' }}>Bahnhofstraße 35</p>
              <p style={{ marginBottom: '0.5rem' }}>42651 Solingen</p>
              <p style={{ marginBottom: '0.5rem' }}>Telefon: <a href="tel:+4921288137120" style={{ color: 'var(--primary)' }}>0212 88137120</a></p>
              <p style={{ marginBottom: '0.5rem' }}>Telefax: 0212 88137119</p>
              <p style={{ marginBottom: '0.5rem' }}>E-Mail: <a href="mailto:marcel.peev@allianz.de" style={{ color: 'var(--primary)' }}>marcel.peev@allianz.de</a></p>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Vertreten durch</h2>
              <p>Marcel Peev</p>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Tätigkeit</h2>
              <p style={{ lineHeight: '1.7' }}>
                Marcel Peev, Beratung zu Versicherungen und deren Vermittlung als gebundener Vertreter 
                (§ 34d Abs. 7 S. 1 Nr. 1 GewO) ausschließlich an die sowie für Rechnung und im Namen der 
                Versicherungsunternehmen der Allianz. Vergütung durch Provisionen und Zusatzvergütungen 
                aus Ausschreibungen (jeweils in der Versicherungsprämie enthalten).
              </p>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Zuständige Berufskammer</h2>
              <p style={{ marginBottom: '0.5rem' }}>Bergische Industrie- und Handelskammer Wuppertal-Solingen-Remscheid</p>
              <p style={{ marginBottom: '0.5rem' }}>Heinrich-Kamp-Platz 2</p>
              <p style={{ marginBottom: '0.5rem' }}>42103 Wuppertal</p>
              <p style={{ marginBottom: '0.5rem' }}>Telefon: 0202/2490-0</p>
              <p style={{ marginBottom: '0.5rem' }}>Telefax: 0202/2490-999</p>
              <p><a href="https://www.bergische.ihk.de/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary)' }}>www.bergische.ihk.de</a></p>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Berufsbezeichnung</h2>
              <p>Marcel Peev, Gebundener Versicherungsvertreter gemäß § 34d Abs. 7 S.1 Nr.1 GewO; Bundesrepublik Deutschland</p>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Versicherungsvermittlerregister</h2>
              <p style={{ marginBottom: '0.5rem' }}>DIHK, Breite Straße 29, 10178 Berlin</p>
              <p style={{ marginBottom: '0.5rem' }}>Tel: 0180 600 58 50 (0,20 €/Anruf)</p>
              <p style={{ marginBottom: '0.5rem' }}>Internet: <a href="https://www.vermittlerregister.info" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary)' }}>www.vermittlerregister.info</a></p>
              <p style={{ marginTop: '1rem' }}><strong>Registernummer:</strong> D-TECQ-V3SIU-24: Marcel Peev</p>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Schlichtungsstellen</h2>
              <p style={{ lineHeight: '1.7', marginBottom: '1rem' }}>
                Die Agentur nimmt verpflichtend an folgenden außergerichtlichen Schlichtungsstellen als 
                Streitbeilegungsstellen i.S.d. Verbraucherstreitbeilegungsgesetzes teil:
              </p>
              <ul style={{ paddingLeft: '1.5rem', lineHeight: '1.8' }}>
                <li>Versicherungsombudsmann e.V., Postfach 080632, 10006 Berlin, E-Mail: <a href="mailto:beschwerde@versicherungsombudsmann.de" style={{ color: 'var(--primary)' }}>beschwerde@versicherungsombudsmann.de</a></li>
                <li>Ombudsmann Private Kranken- und Pflegeversicherung, Postfach 060222, 10052 Berlin, E-Mail: <a href="mailto:ombudsmann@pkv.de" style={{ color: 'var(--primary)' }}>ombudsmann@pkv.de</a></li>
                <li>Ombudsmann Bundesverband deutscher Banken, Postfach 040307, 10062 Berlin, E-Mail: <a href="mailto:bankenverband@bdb.de" style={{ color: 'var(--primary)' }}>bankenverband@bdb.de</a></li>
              </ul>
            </div>

            <div style={{ marginBottom: '2rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Berufsrechtliche Regelungen</h2>
              <ul style={{ paddingLeft: '1.5rem', lineHeight: '1.8' }}>
                <li>§ 34d Gewerbeordnung (GewO)</li>
                <li>§§ 59–68 Gesetz über den Versicherungsvertrag (VVG)</li>
                <li>Verordnung über die Versicherungsvermittlung und -beratung (VersVermV)</li>
              </ul>
              <p style={{ marginTop: '1rem', lineHeight: '1.7' }}>
                Die berufsrechtlichen Regelungen können über die vom Bundesministerium der Justiz und für 
                Verbraucherschutz und der von der juris GmbH betriebenen Homepage{' '}
                <a href="https://www.gesetze-im-internet.de" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary)' }}>www.gesetze-im-internet.de</a>{' '}
                eingesehen und abgerufen werden.
              </p>
            </div>

            <div>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Verantwortlicher im Sinne des § 18 Abs. 2 MStV</h2>
              <p>Marcel Peev</p>
            </div>
          </div>

          <div style={{ marginTop: '3rem', textAlign: 'center' }}>
            <a href="/" className="btn-primary">Zurück zur Startseite</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Impressum;
